export const SETOR_FOLHA_LOAD = "SETOR_FOLHA_LOAD";
export const SETOR_RAIZ_LOAD = "SETOR_RAIZ_LOAD";
export const SETROR_FILHO_LOAD = "SETROR_FILHO_LOAD";
export const TODOS_SETORES = "TODOS_SETORES";
